import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { AttributeType } from "@evergis/api";

import { useLayerAttributeOptions } from "../../../../hooks/attributes/useLayerAttributeOptions";
import { isNumberAttribute } from "../../../../interfaces/service";
import { AttributeOption } from "../../../../evergis/core/attributes/createAttributeOption";

export const newAttributeOptionValue = "newAttribute";

export const getNumberAttributesList = (attributeOptions: AttributeOption[]) => {
  return attributeOptions.filter(({ type }) => type && isNumberAttribute(type as AttributeType));
};

export const useCurrentAttributesList = (layerName?: string): AttributeOption[] => {
  const { t } = useTranslation("dialogs");
  const attributeOptions = useLayerAttributeOptions(layerName, { withDefault: true });
  const [emptyOption, ...options] = attributeOptions;

  const newAttributeOption: AttributeOption = useMemo(
    () => ({
      text: t("featuresMultiEdit.newAttribute"),
      description: "",
      value: newAttributeOptionValue,
      primary: true,
    }),
    [t],
  );

  return [emptyOption, newAttributeOption, ...options];
};
